import React from 'react'
import UploadService from '../../services/UploadFiles.js'
import { MainContext } from '../MainContext.js'
import PropTypes from 'prop-types'

export default class UploadFiles extends React.Component {
  static contextType = MainContext
  constructor(props) {
    super(props)
    this.selectFiles = this.selectFiles.bind(this)
    this.upload = this.upload.bind(this)
    this.uploadFiles = this.uploadFiles.bind(this)

    this.state = {
      receiptFile: {},
      selectedFiles: undefined,
      progressInfos: [],
      message: [],
      fileInfos: [],
    }
  }
  selectFiles(event) {
    this.setState({
      progressInfos: [],
      selectedFiles: event.target.files,
    })
  }

  upload(idx, file) {
    const _progressInfos = [...this.state.progressInfos]
    UploadService
      .upload(
        file,
        this.props.userId,
        this.props.reimbursementItem.id,
        event => {
          _progressInfos[idx].percentage = Math.round(
            (100 * event.loaded) / event.total,
          )
          this.setState({
            _progressInfos,
          })
        },
      )
      .then(response => {
        const dataResponse = response.data.data.attributes
        this.props.reimbursementItemReceipts(dataResponse)
        this.setState({
          fileInfos: response.data,
        })
      })
      .catch(err => {
        _progressInfos[idx].percentage = 0
        this.setState(prev => {
          const nextMessage = [
            ...prev.message,
            `Could not upload the file: ${file.name} : ${err.response.data.server_error}`,
          ]
          return {
            progressInfos: _progressInfos,
            message: nextMessage,
          }
        })
      })
  }

  uploadFiles() {
    const selectedFiles = this.state.selectedFiles
    const _progressInfos = []
    for (let i = 0; i < selectedFiles.length; i++) {
      _progressInfos.push({ percentage: 0, fileName: selectedFiles[i].name })
    }

    this.setState(
      {
        progressInfos: _progressInfos,
        message: [],
      },
      () => {
        for (let i = 0; i < selectedFiles.length; i++) {
          this.upload(i, selectedFiles[i])
        }
      },
    )
  }

  render() {
    const { selectedFiles, message } = this.state

    return (
      <div className="card">
        {this.props.reimbursementItem.type === 'mileage' ? (
          <div className="text-lg font-bold">
            Upload a screenshot of the map of your route including starting and
            ending location
          </div>
        ) : null}
        <div className="md:flex items-center mt-4">
          <div className="w-full flex flex-col">
            <label className="">
              <input
                type="file"
                id="file"
                name="file"
                multiple
                onChange={this.selectFiles}
              />
            </label>
          </div>
        </div>
        <div className="md:flex items-center mt-4">
          <div className="w-full flex flex-col">
            <button
              id="continue-button-upload"
              className="w-full mt-9 font-semibold leading-none text-white py-4 px-10 bg-cyan-700 rounded hover:bg-cyan-400 focus:ring-2 focus:ring-offset-2 focus:ring-blue-700 focus:outline-none "
              disabled={!selectedFiles}
              onClick={this.uploadFiles}
            >
              Continue to Review
            </button>
          </div>
        </div>
        {message.length > 0
          && message.map((item, i) => {
            return (
              <div
                key={i}
                className="bg-red-500 shadow-lg mx-auto w-96 max-w-full text-sm pointer-events-auto bg-clip-padding rounded-lg block mb-1"
                id="static-example"
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
                data-mdb-autohide="true"
              >
                <div className="bg-red-500  flex justify-between items-center py-2 px-3 bg-clip-padding border-b border-white-400 rounded-t-lg">
                  <p className="font-bold text-white flex items-center">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="check-circle"
                      className="w-4 h-4 mr-2 fill-current"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        // eslint-disable-next-line
                        d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                      ></path>
                    </svg>
                    File:
                  </p>
                  <div className="flex items-center">
                    <p className="text-white opacity-90 text-xs">Failed</p>
                    <button
                      type="button"
                      className="btn-close btn-close-white box-content w-4 h-4 ml-2 text-white border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-white hover:opacity-75 hover:no-underline"
                      data-mdb-dismiss="toast"
                      aria-label="Close"
                    ></button>
                  </div>
                </div>
                <div className="p-3 bg-red-500 rounded-b-lg break-words text-white">
                  {item}
                </div>
              </div>
            )
          })}
      </div>
    )
  }
}
UploadFiles.propTypes = {
  userId: PropTypes.number,
  reimbursementItem: PropTypes.object,
  reimbursementItemReceipts: PropTypes.func,
}
